import { defineTransform } from '@client/core/data/concerns/parses-from-json/transform-map';
import { Nullable } from '@client/core/data/types';
import { parseISO } from '@client/core/utils/date';

/**
 * @see app/Models/ProjectMilestonesConstructionDateSource.php
 */
export enum ProjectMilestonesConstructionDataSource {
  Scheduler = 'scheduler',
  Project = 'project',
}

/**
 * Significant dates for a Project.
 *
 * @see app/Http/Resources/Project/ProjectMilestonesResource.php
 */
export class ProjectMilestones {
  constructor(
    public readonly purchaseDate: Nullable<Date>,
    public readonly constructionStartDate: Nullable<Date>,
    public readonly constructionEndDate: Nullable<Date>,
    public readonly openHouseDate: Nullable<Date>,
    public readonly saleDate: Nullable<Date>,
    public readonly daysHeld: number,
  ) {}
}

defineTransform(ProjectMilestones, (json, { fromSnakeCaseKeys, nullOr }) => {
  return {
    ...fromSnakeCaseKeys(),
    purchaseDate: nullOr(json.purchase_date, () => parseISO(json.purchase_date)),
    constructionStartDate: nullOr(json.construction_start_date, () => parseISO(json.construction_start_date)),
    constructionEndDate: nullOr(json.construction_end_date, () => parseISO(json.construction_end_date)),
    openHouseDate: nullOr(json.open_house_date, () => parseISO(json.open_house_date)),
    saleDate: nullOr(json.sale_date, () => parseISO(json.sale_date)),
  };
});
